export default "__VITE_PUBLIC_ASSET__05547563__"